export const LOAN_STATE = {
  PENDING: 'pending',
  ACTIVE: 'active',
  DEFAULTED: 'defaulted',
  CLOSED: 'closed',
  CANCELLED: 'cancelled',
  SOLD: 'sold',
} as const;

export type LoanStateType = (typeof LOAN_STATE)[keyof typeof LOAN_STATE];
